export default __webpack_public_path__ + "static/media/demo1.886d46ba.png";